<script>
  import { onMount } from "svelte";

  import ExploreSeeds from "../../components/Seeds/ExploreSeeds.svelte";
  import ExploreGrow from "../../components/Grow/ExploreGrow.svelte";
  import ExploreHarvest from "../../components/Harvest/ExploreHarvest.svelte";

  import CalendarList from "../../components/Calendar/CalendarList.svelte";

  import seeds from "../../components/Seeds/seeds-store.js";
  import seedbank from "../../components/Seeds/seedbank-store.js";


  import { queryData } from "../../helpers/api.js";
  import routes from "../../routes/routes.js";
  import page from "page";

  export let locationText;
  // export let stationName;
  // export let climatePrecipitation;

  let exploreMode;
  let seedSubset = [];
  let plantSubset = [];
  let plotsSubset = [];

  let plantName;

  let data = null;
  let currentPage = routes.rand;
  let locationSet = false;

  function setPage({ params: { page, view } }) {
    currentPage = routes[page];
    // console.log("setPage", currentPage);
  }

  function updateAfterMoving(ctx) {
    ctx.path += `?currentQuery`;
    ctx.save();
  }
  page(
    "/",
    () => setPage({ params: { page: "rand", view: "test" } }),
    updateAfterMoving
  );
  page("/:page/:view", setPage);
  page({ hashbang: true });

  function addInput(event) {
    // console.log("addInput", event.detail.numberInput);
  }

  function updateQueryString(query) {
    if (window.history.replaceState) {
      let hash = window.location.hash.split("?")[0];
      if (hash.length === 0 || hash === "#!/") {
        hash = "";
      }
      const newURL = `${window.location.origin}${window.location.pathname}${hash}?${query}`;
      window.history.replaceState(null, null, newURL);
    }
  }

  let mounted = false;
  onMount(() => {
    mounted = true;
  });

  function planGarden(event) {
    locationText = event.detail.locationText;
    const newPlan = {
      id: Math.random().toString(),
      locationText: event.detail.locationText,
      plantsSubset: event.detail.plantsSubset,
    };

    cancelLocation();
    data = queryData(newPlan).then((value) => {
    data = value
    });

  }

  function cancelLocation() {
    locationSet = true;
  }

  function toggleSeeds(event) {
    plantName = event.detail;
    seedSubset = [...$seeds.filter((s) => s.plantName === plantName)];

    exploreMode = "seed";
  }

  function toggleGrow(event) {
    plantName = event.detail;
    exploreMode = "grow";
  }

  function toggleHarvest(event) {
    plantName = event.detail;
    exploreMode = "harvest";
  }

  function cancelSeedExplore() {
    exploreMode = "cancel";
  }

  function addSeed(event) {
    const id = event.detail;
    const seedData = { ...$seeds.filter((s) => s.id === id) };
    seedbank.addSeed(seedData);
  }
</script>

<style>
  .intermission {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    height: 500px;
  }
</style>

<main>
  {#await data}
  <div class="intermission">
    <p>
    ...personalizing insights for {locationText}...
    </p>
  </div>
  {:then data}
  <CalendarList
    {data}
    {locationText}
    {locationSet}
    on:toggleseeds={toggleSeeds}
    on:togglegrow={toggleGrow}
    on:toggleharvest={toggleHarvest}
    on:plangarden={planGarden}
  />
  {:catch error}
    <p style="color: red">{error.message}</p>
  {/await}

  {#if exploreMode === "seed"}
    <ExploreSeeds
      {seedSubset}
      {exploreMode}
      {plantName}
      on:buy-now={addSeed}
      on:cancel={cancelSeedExplore}
    />
  {:else if exploreMode === "grow"}
    <ExploreGrow
    {plantName}
    on:cancel={cancelSeedExplore}
    />
  {:else if exploreMode === "harvest"}
    <ExploreHarvest
    {plantName}
    on:cancel={cancelSeedExplore}
    />
  {/if}
</main>
